import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({ name: 'img' })
export class ImgPipe implements PipeTransform {
	constructor() {}

	transform(path: string) {
		return environment.apiImages + path;
	}
}
